/** Only static, safe messages may be attached to this error. */
export class RuntimeSecretResolutionError extends Error {}

export type RuntimeSecretsPlatformDef = {
  listAliases: (
    teamID: string,
    environmentID: string,
    signal: AbortSignal
  ) => Promise<string[]>
  resolve: (
    teamID: string,
    environmentID: string,
    aliases: string[],
    signal: AbortSignal
  ) => Promise<Record<string, string>>
}
